import { GridCellKind } from '@glideapps/glide-data-grid';
import type { CustomCell, CustomRenderer } from '@glideapps/glide-data-grid';
import { paintLines } from './chipPainting.js';

export interface LinesCellData {
  readonly kind: 'lines';
  readonly lines: readonly string[];
  /** What the cell reads, muted, when there is nothing to list. */
  readonly empty: string;
  /**
   * How many items this cell is a summary of, when that can exceed
   * `lines.length` itself — a feed that sends only the first few. Defaults to
   * `lines.length`, i.e. nothing beyond what was sent.
   */
  readonly totalCount?: number;
}

export type LinesCell = CustomCell<LinesCellData>;

/**
 * A short list read one item to a line, as many lines as the row is tall.
 * Read-only: every line of it is something a feed wrote, not a value a person
 * types back in here.
 */
export const linesRenderer: CustomRenderer<LinesCell> = {
  kind: GridCellKind.Custom,
  isMatch: (cell: CustomCell): cell is LinesCell =>
    'kind' in cell.data && cell.data.kind === 'lines',
  draw: (args, cell) => {
    paintLines(args, cell.data.lines, cell.data.empty, cell.data.totalCount);
  },
};

export function linesCell(lines: readonly string[], empty: string, totalCount?: number): LinesCell {
  return {
    kind: GridCellKind.Custom,
    allowOverlay: false,
    copyData: lines.join('; '),
    data: { kind: 'lines', lines, empty, ...(totalCount === undefined ? {} : { totalCount }) },
  };
}
